export default "__VITE_ASSET__BhmfBKW4__"